<template>
  <div>
    <b-card no-body>
      <template v-if="dataList.length">
        <b-table
          responsive="sm"
          :fields="fields"
          :items="dataList"
          striped
        >
          <template #cell(ddate)="data">
            {{ moment(data.item.ddate).format('DD.MM.YYYY') }}
          </template>
          <template #cell(donation_group)="data">
            <div>
              <div class="text-primary font-weight-bold">
                {{ data.item.donation_group }}
              </div>
              <div class="text-muted font-small-2">
                {{ data.item.notes }}
              </div>
              <div>
                <b-badge :variant="data.item.id_donation_types === '1'? 'light-warning' : 'light-danger'">
                  {{ data.item.donation_type }}
                </b-badge>
              </div>
            </div>
          </template>
          <template #cell(amount)="data">
            <div
              v-if="data.item.is_income"
              class="text-success font-weight-bold"
            >
              +{{ data.item.amount | toCurrency }} {{ data.item.currency }}
            </div>
            <div
              v-if="data.item.is_expense"
              class="text-danger font-weight-bold"
            >
              {{ data.item.amount | toCurrency }} {{ data.item.currency }}
            </div>
          </template>
          <template #cell(is_expense)="data">
            <div
              v-if="data.item.is_expense"
              class="text-danger font-weight-bold"
            >
              -{{ data.item.amount | toCurrency }} {{ data.item.currency }}
            </div>
          </template>
          <template #cell(control)="data">
            <b-button
              variant="danger"
              size="sm"
              @click="openModal(data.item)"
            >
              <FeatherIcon icon="CheckIcon" /> Banka Transferi
            </b-button>
          </template>
        </b-table>
        <b-card-footer>
          <b-pagination
            v-model="currentPage"
            :total-rows="dataCounts"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </b-card-footer>
      </template>
      <b-card-body
        v-else
        class="pb-0"
      >
        <b-alert
          show
          variant="info"
        >
          <div class="alert-body text-center">
            <FeatherIcon icon="InfoIcon" />
            <p>Banka hesabına transfer edilecek işlem bulunmamaktadır.</p>
          </div>
        </b-alert>
      </b-card-body>
      <transfer-modal />
    </b-card>
  </div>
</template>
<script>
import {
  BCard, BBadge, BTable, BPagination, BCardFooter, BButton, BAlert, BCardBody,
} from 'bootstrap-vue'
import TransferModal from '@/views/Admin/Account_activities/Components/TransferModal.vue'
import toastMixin from '@/libs/toast'

export default {
  name: 'BankTransfer',
  components: {
    BCard,
    BBadge,
    BTable,
    BPagination,
    BCardFooter,
    BButton,
    BAlert,
    BCardBody,
    TransferModal,
  },
  mixins: [toastMixin],
  data() {
    return {
      currentPage: 1,
      perPage: this.$store.state.app.perPage,
      fields: [
        {
          key: 'ddate',
          label: 'TARİH',
          thClass: 'width-100 text-nowrap',
          tdClass: 'width-100 text-nowrap',
        },
        {
          key: 'donation_group',
          label: 'Tanım',
        },
        {
          key: 'amount',
          label: 'TUTAR',
          thClass: 'width-50 text-nowrap text-right',
          tdClass: 'width-50 text-nowrap text-right',
        },
        {
          key: 'control',
          label: '',
          thClass: 'width-50 text-nowrap',
          tdClass: 'width-50 text-nowrap',
        },
      ],
      dataQuery: {
        limit: this.$store.state.app.perPage,
        start: 0,
      },
    }
  },
  computed: {
    filterParams() {
      return this.$store.getters['accountActivities/filterParams']
    },
    dataList() {
      return this.$store.getters['accountActivities/dataList']
    },
    dataCounts() {
      return this.$store.getters['accountActivities/dataCounts']
    },
    saveData() {
      return this.$store.getters['accountActivities/dataSaveStatus']
    },
    transferModal() {
      return this.$store.getters['accountActivities/transferModal']
    },
    transferDataItem() {
      return this.$store.getters['accountActivities/transferDataItem']
    },
  },
  watch: {
    currentPage(val) {
      this.dataQuery.start = (val - 1) * this.$store.state.app.perPage
      this.getDataList()
    },
    saveData() {
      this.getDataList()
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    openModal(data) {
      this.transferModal.status = true
      this.transferModal.dataItem = data
      this.transferDataItem.id = data.id
      this.transferDataItem.amount = data.amount
      this.transferDataItem.former_amount = data.amount
      this.transferDataItem.id_donation_types = data.id_donation_types
      this.transferDataItem.id_donation_groups = data.id_donation_groups
      this.transferDataItem.receipt_no = data.receipt_no
      this.transferDataItem.id_currencies = data.id_currencies
      this.transferDataItem.notes = `${data.receipt_no} numaralı makbuzlu işleme istinaden banka hesabına yatırılmıştır.`
    },
    getDataList() {
      this.$store.dispatch('accountActivities/getBankTransfer', this.dataQuery)
    },
  },
}
</script>
